module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_4_m.92edfbbd749958f6abe1f1d157bca758.png";